module.exports = __webpack_public_path__ + "img/08_WebFlow_13-3.65012203.svg";